module.exports = __webpack_public_path__ + "img/mazer-hero.890cf716.jpg";